function definePolyfill(target, key, value) {
  try {
    Object.defineProperty(target, key, {
      configurable: true,
      writable: true,
      value
    });
  } catch (error) {
    target[key] = value;
  }
}

function toArray(iterable) {
  if (Array.from) {
    return Array.from(iterable);
  }

  var items = [];
  for (var index = 0; index < iterable.length; index += 1) {
    items.push(iterable[index]);
  }
  return items;
}

if (typeof Promise !== 'undefined' && !Promise.allSettled) {
  definePolyfill(Promise, 'allSettled', function allSettled(iterable) {
    return Promise.all(
      toArray(iterable).map(function settle(item) {
        return Promise.resolve(item).then(
          function onFulfilled(value) {
            return { status: 'fulfilled', value: value };
          },
          function onRejected(reason) {
            return { status: 'rejected', reason: reason };
          }
        );
      })
    );
  });
}

if (!Object.fromEntries) {
  definePolyfill(Object, 'fromEntries', function fromEntries(entries) {
    if (entries == null) {
      throw new TypeError('Object.fromEntries() requires a single iterable argument');
    }

    var object = {};
    var hasIterator = typeof Symbol !== 'undefined' && entries[Symbol.iterator];

    if (hasIterator) {
      var iterator = entries[Symbol.iterator]();
      var step = iterator.next();
      while (!step.done) {
        var pair = step.value;
        object[pair[0]] = pair[1];
        step = iterator.next();
      }
      return object;
    }

    for (var index = 0; index < entries.length; index += 1) {
      var arrayPair = entries[index];
      object[arrayPair[0]] = arrayPair[1];
    }

    return object;
  });
}

function flattenInto(input, depth, output) {
  for (var index = 0; index < input.length; index += 1) {
    if (!(index in input)) {
      continue;
    }

    var value = input[index];
    if (depth > 0 && Array.isArray(value)) {
      flattenInto(value, depth - 1, output);
    } else {
      output.push(value);
    }
  }
}

if (!Array.prototype.flat) {
  definePolyfill(Array.prototype, 'flat', function flat(depth) {
    var output = [];
    var requestedDepth = depth === undefined ? 1 : depth;
    var normalizedDepth =
      requestedDepth === Infinity ? Infinity : Math.max(Number(requestedDepth) || 0, 0);
    flattenInto(Object(this), normalizedDepth, output);
    return output;
  });
}

if (!Array.prototype.flatMap) {
  definePolyfill(Array.prototype, 'flatMap', function flatMap(callback, thisArg) {
    return Array.prototype.map.call(this, callback, thisArg).flat();
  });
}
